var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"library-upload-component"},[_c('div',{on:{"click":_vm.uploadMediaClick}},[_vm._t("default")],2),_c('input',{ref:"inputFile",staticStyle:{"display":"none"},attrs:{"name":"file","type":"file","multiple":"multiple","accept":"image/*, video/mp4, video/mov"},on:{"change":_vm.upload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }